import React, { useState } from "react";
import Navbar from "../Components/Navbar";
import axios from 'axios'
import { Link , useNavigate } from "react-router-dom";





function SignUp() {

    const [name,setname]=useState("")
    const [location,setlocation]=useState("")
    const [email,setemail]=useState("")
    const [password,setpassword]=useState("")

    const handleNmae=(e)=>{
          setname(e.target.value)
    }
    const handleLocation=(e)=>{
        setlocation(e.target.value)
  }
  const handleEmail=(e)=>{
    setemail(e.target.value)
}
const handlePassword=(e)=>{
    setpassword(e.target.value)
}

let navigate=useNavigate()

    const handleApi = (e) => {
        e.preventDefault();
        axios.post('https://gofoodies.onrender.com/createFoodUser',{
            name:name,
            location:location,
            email:email,
            password:password
        })
        .then(result=>{
            console.log(result.data.data)
            alert("User create succesfully")
            navigate('/login')
        })
        .catch(err=>{
          console.log(err.response.data.msg)
          alert(err.response.data.msg)
        })
        
      }
    
    return (
        <div>
            <Navbar />
            <div className="container bg-secondary mt-4 rounded-3 ">
                <form >
                    <div className="mb-3">
                        <label className="form-label">
                            Name
                        </label>
                        <input onChange={handleNmae} value={name} type="text" className="form-control" />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">
                            Location
                        </label>
                        <input  onChange={handleLocation} value={location} type="text" className="form-control" />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">
                            Email address
                        </label>
                        <input  onChange={handleEmail} value={email} type="email" class="form-control" id="exampleInputEmail1" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">
                            Password
                        </label>
                        <input
                         onChange={handlePassword}
                         value={password}
                            type="password"
                            className="form-control"

                        />
                    </div>

                    <button onClick={handleApi} type="submit" className="m-3 btn btn-success">
                        Submit
                    </button>
                    
                    <Link to='/login' className="m-3 btn btn-danger ">Already a User</Link>
                    
                </form>
            </div>
        </div>
    );
}

export default SignUp;
